export const METHOD_TYPE_DELETE = 'DELETE';
export const METHOD_TYPE_GET = 'GET';
export const METHOD_TYPE_POST = 'POST';
export const METHOD_TYPE_PUT = 'PUT';
